import * as types from './mutation-types';
import * as Constants from "../constants";

export default {
    [types.INCREMENT](state) {
        state.step++;
    },
    [types.DECREMENT](state) {
        state.step = Math.max(1, state.step - 1);
    },
    [types.RESET](state) {
        state.step = 1;
    },
    [types.NEW_PREVIEW](state, preview) {
        state.preview = preview.code;
        state.preview_date = Date.now();
        state.header_count = 0;
        state.header_url = null;
        state.header_file = null;
    },
    [types.FINISH_PREVIEW](state) {
        state.preview = null;
        state.preview_date = 0;
        state.header_count = 0;
        state.header_url = null;
        state.header_file = null;
    },
    [types.INCREMENT_HEADERCOUNT](state) {
        state.header_count += 1;
    },
    [types.RESET_HEADERCOUNT](state) {
        state.header_count = 0;
    },
    [types.INCREMENT_TILECOUNT](state) {
        state.tile_count += 1;
    },
    [types.RESET_TILECOUNT](state) {
        state.tile_count = 0;
    },
    [types.SET_HEADER_URL](state, preview) {
        state.header_url = Constants.STORAGE_URL + preview.code + '/header/default/header_thumbnail.jpg?t=' + Date.now();
    },
    [types.SET_HEADER_FILE](state, file) {
        state.header_file = file;
    },
    [types.RESET_HEADER](state) {
        state.header_url = null;
        state.header_count = 0;
        state.header_file = null;
    },
    [types.TILE_IMAGE_UPLOADED](state, file) {
        state.tile_images.push(file);
    },
    [types.TILE_IMAGE_DELETED](state, filename) {
        //state.tile_count -= 1;
        for(let i = 0; i < state.tile_images.length; i++) {
            if(state.tile_images[i].name === filename) {
                state.tile_images.splice(i, 1);
                state.tile_count -= 1;
            }
        }
    },
    [types.TILE_IMAGES_RESET](state) {
        state.tile_images = [];
    },
    [types.SET_EMAIL](state, email) {
        state.email = email;
    }
};
